module.exports = __webpack_public_path__ + "static/media/objects_16.a9762c68.svg";